exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "/* purgecss start ignore */\n.soundkit-header__details--description {\n  max-width: 100%;\n  word-wrap: break-word;\n  word-break: break-word;\n  white-space: normal;\n}\n\n/* purgecss end ignore */\n", ""]);
